import { secretKey } from "../../../util/config";
import { SetDevKey, setToken } from "../../../util/setAuth";
import * as ActionType from "./badge.type";
import jwt_decode from "jwt-decode";

const initialState = {
  badgeUser: [],
  unBadgeUser: [],
};

export const badgeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GETBADGEUSERS:
      return {
        ...state,
        badgeUser: action.payload.badgeUser,
        unBadgeUser: action.payload.unBadgeUser,
      };
    default:
      return state;
  }
};
